(() => {
  const initBrakeRefinishingGallery = (root) => {
    if (!root || root.dataset.ecprBrakeGalleryReady === 'true') return;

    const modal = document.querySelector('#ECPRBrakeGalleryModal');
    if (!modal) return;

    const modalImage = modal.querySelector('.ecpr-brakes-modal__image');
    const modalCaption = modal.querySelector('[data-ecpr-lightbox-caption]');
    const modalDialog = modal.querySelector('[role="dialog"]');
    const fallbackMode = typeof modal.show !== 'function';
    let lastTrigger = null;

    const closeFallbackModal = () => {
      if (!fallbackMode || !modal.hasAttribute('open')) return;
      modal.removeAttribute('open');
      lastTrigger?.focus();
    };

    if (fallbackMode && modal.dataset.ecprFallbackReady !== 'true') {
      modal.querySelector('.ecpr-brakes-modal__close')?.addEventListener('click', closeFallbackModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeFallbackModal();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeFallbackModal();
      });
      modal.dataset.ecprFallbackReady = 'true';
    }

    root.querySelectorAll('[data-ecpr-lightbox]').forEach((button) => {
      button.addEventListener('click', () => {
        const thumbnail = button.querySelector('img');
        const fullSource = button.dataset.fullSrc || thumbnail?.currentSrc || thumbnail?.src || '';
        const alt = button.dataset.alt || thumbnail?.alt || '';

        if (modalImage) {
          modalImage.src = fullSource;
          modalImage.alt = alt;
        }

        if (modalCaption) modalCaption.textContent = alt;

        if (typeof modal.show === 'function') {
          modal.show(button);
        } else {
          lastTrigger = button;
          modal.setAttribute('open', '');
          modalDialog?.focus();
        }
      }, { capture: true });
    });

    root.dataset.ecprBrakeGalleryReady = 'true';
  };

  const projectReviewTargets = {
    'pads-rotors': {
      selector: 'select[id*="pads-rotors"]',
      optionText: 'Quote replacement',
      label: 'Pads & Rotors'
    },
    'brake-fluid': {
      selector: 'input[type="checkbox"][id*="brake-fluid-service"]',
      label: 'Brake Fluid Service'
    },
    'stainless-lines': {
      selector: 'input[type="checkbox"][id*="stainless-brake-lines"]',
      label: 'Stainless Brake Lines'
    },
    'bbk-installation': {
      selector: 'input[type="checkbox"][id*="bbk-installation"]',
      label: 'BBK Installation'
    },
    'carbon-ceramic': {
      selector: 'select[id*="brake-system-type"]',
      optionText: 'Carbon-ceramic system',
      label: 'Brake System Type'
    },
    'track-preparation': {
      selector: 'input[type="checkbox"][id*="track-preparation"]',
      label: 'Track Preparation'
    }
  };

  const dispatchControlEvents = (control) => {
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const initProjectReviewEnhancements = () => {
    const page = document.querySelector('[data-ecpr-brake-refinishing]');
    const form = document.querySelector('form#project-review');
    if (!page || !form) return;

    const richTextBlocks = Array.from(form.querySelectorAll('.flexi-richtext'));
    richTextBlocks.find((block) => block.textContent.includes('Photos of all four calipers are required'))?.classList.add('ecpr-photo-submission');
    richTextBlocks.find((block) => block.textContent.includes('By submitting, you authorize EuroCustomsPR'))?.classList.add('ecpr-project-consent');

    let status = form.querySelector('[data-ecpr-capability-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'visually-hidden';
      status.dataset.ecprCapabilityStatus = '';
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }

    const setImmediateScrollTop = (top) => {
      const scrollingElement = document.scrollingElement || document.documentElement;
      const previousBehavior = scrollingElement.style.scrollBehavior;

      scrollingElement.style.scrollBehavior = 'auto';
      scrollingElement.scrollTop = Math.max(0, top);
      window.requestAnimationFrame(() => {
        scrollingElement.style.scrollBehavior = previousBehavior;
      });
    };

    const scrollToProjectReview = () => {
      const top = form.getBoundingClientRect().top + window.scrollY - 16;
      setImmediateScrollTop(top);
    };

    page.querySelectorAll('a[href="#project-review"]:not([data-ecpr-form-target])').forEach((link) => {
      if (link.dataset.ecprProjectReviewReady === 'true') return;

      link.addEventListener('click', (event) => {
        event.preventDefault();

        try {
          window.history.replaceState(null, '', '#project-review');
        } catch {
          window.location.hash = 'project-review';
        }

        scrollToProjectReview();
      });

      link.dataset.ecprProjectReviewReady = 'true';
    });

    if (window.location.hash === '#project-review' && form.dataset.ecprInitialHashReady !== 'true') {
      form.dataset.ecprInitialHashReady = 'true';
      const settleProjectReviewAnchor = () => window.setTimeout(scrollToProjectReview, 300);

      if (document.readyState === 'complete') {
        settleProjectReviewAnchor();
      } else {
        window.addEventListener('load', settleProjectReviewAnchor, { once: true });
      }

      window.setTimeout(scrollToProjectReview, 900);
    }

    page.querySelectorAll('[data-ecpr-form-target]').forEach((link) => {
      if (link.dataset.ecprFormTargetReady === 'true') return;

      link.addEventListener('click', (event) => {
        const config = projectReviewTargets[link.dataset.ecprFormTarget];
        const control = config ? form.querySelector(config.selector) : null;
        if (!control) return;

        event.preventDefault();

        if (control instanceof HTMLSelectElement && config.optionText) {
          const option = Array.from(control.options).find((item) => item.textContent.trim() === config.optionText);
          if (option) control.value = option.value;
        } else if (control instanceof HTMLInputElement && control.type === 'checkbox') {
          control.checked = true;
        }

        dispatchControlEvents(control);

        const target = control.closest('.flexi-block') || control.closest('.field') || control;
        target.classList.remove('ecpr-capability-highlight');
        target.classList.add('ecpr-capability-highlight');
        window.setTimeout(() => target.classList.remove('ecpr-capability-highlight'), 2200);

        try {
          window.history.replaceState(null, '', '#project-review');
        } catch {
          window.location.hash = 'project-review';
        }

        const targetTop = target.getBoundingClientRect().top + window.scrollY - ((window.innerHeight - target.offsetHeight) / 2);
        setImmediateScrollTop(targetTop);
        control.focus({ preventScroll: true });
        status.textContent = `${config.label} selected in the project-review form.`;
      });

      link.dataset.ecprFormTargetReady = 'true';
    });
  };

  document.querySelectorAll('[data-ecpr-brake-refinishing]').forEach(initBrakeRefinishingGallery);
  initProjectReviewEnhancements();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-ecpr-brake-refinishing]')) {
      initBrakeRefinishingGallery(event.target);
      initProjectReviewEnhancements();
      return;
    }

    event.target.querySelectorAll?.('[data-ecpr-brake-refinishing]').forEach(initBrakeRefinishingGallery);
    initProjectReviewEnhancements();
  });
})();
